import styles from './discussions.module.css'

import * as React from 'react'

import { MdInfoOutline } from '@react-icons/all-files/md/MdInfoOutline'

import type { DiscussionVisibility } from 'types/discussion'

import { AccessibleIcon, Flex, SegmentedControl, Tooltip } from 'components/ds'

const INTERNAL_TOOLTIP_TEXT =
  'Only visible to users in your DISCO, use these for context or instructions meant for your team.'
export const EXTERNAL_TOOLTIP_TEXT =
  'Visible to clients and end users, including on public download pages.'

type Props = {
  value: DiscussionVisibility
  onValueChange: (visibility: DiscussionVisibility) => void
}

const VisibilityInfoTooltip = ({
  content,
}: {
  content: string
}): React.ReactElement => (
  <Tooltip content={content}>
    {/* tabIndex={-1}: SegmentedControl.Item renders this twice (active/inactive
    label crossfade) and is itself a button, so this must stay out of the tab
    order rather than become a focusable nested control */}
    <span className={styles.infoIcon} tabIndex={-1}>
      <AccessibleIcon label="More info">
        <MdInfoOutline size="14" />
      </AccessibleIcon>
    </span>
  </Tooltip>
)

const DiscussionVisibilityControl = ({
  value,
  onValueChange,
}: Props): React.ReactElement => (
  <SegmentedControl.Root
    value={value}
    onValueChange={v => onValueChange(v as DiscussionVisibility)}
    className={styles.tabsRoot}
  >
    <SegmentedControl.Item value="internal">
      <Flex align="center" gap="1">
        Internal Notes
        <VisibilityInfoTooltip content={INTERNAL_TOOLTIP_TEXT} />
      </Flex>
    </SegmentedControl.Item>
    <SegmentedControl.Item value="client">
      <Flex align="center" gap="1">
        Client Notes
        <VisibilityInfoTooltip content={EXTERNAL_TOOLTIP_TEXT} />
      </Flex>
    </SegmentedControl.Item>
  </SegmentedControl.Root>
)

export default DiscussionVisibilityControl
